<template>
  <el-select :value="value" placeholder="Select">
    <el-option label="Español (Colombia)" value="es-CO"></el-option>
    <el-option label="English (United States)" value="en-US"></el-option>
  </el-select>
</template>
<script>
export default {
  props: {
    value: { type: String },
  },
  mounted() {
    this.$emit('input', 'es-CO')
  },
  methods: {
    onChange(e) {
      this.$emit('input', e)
    },
  },
}
</script>
